import React from 'react'
import * as commentStyles from '../../styles/project-modules/bills/reportercomment.module.less'

function ReporterComment({ publicationName, comment, reporter=null }) {
  return (
    <div className={commentStyles.container}>
      <h4 className={commentStyles.title}>
        {/* {publicationName.replace('The', '')} newsroom note ... */}
        Reporter's Note
      </h4>
      <p
        className={commentStyles.text}
        dangerouslySetInnerHTML={{ __html: comment }}
      ></p>
      { reporter && <i className={commentStyles.text}>— <span dangerouslySetInnerHTML={{ __html: reporter}}></span></i>}
    </div>
  )
}

export default ReporterComment
